import React from 'react';
import { currencyFormat } from '../../helpers/index';
import TruncateMarkup from 'react-truncate-markup';
import Scroll from 'react-scroll';
import { getWindowScrollTop } from '../../helpers';

export const getHeroTextBlock = (theme, propertyInfo, heroInfo) => {
    let address;
    const moreLinkClick = () => {
        Scroll.animateScroll.scrollTo(
            document.getElementById('description').getBoundingClientRect().top + getWindowScrollTop()
        );
    }
    const moreLink = (
        <span>...<a onClick={moreLinkClick} className="more-link" href="#">-more-</a></span>
    );

    switch (theme) {
        case 'cottage':
            address = propertyInfo.address.city;
            address = address.length
                ? address + ', ' + propertyInfo.address.state
                : propertyInfo.address.state;
            return (
                <div className="main-text-component-wrapper">
                    <div className="main-text-component-content">
                        <h1>{propertyInfo.title}</h1>
                        <h2 className="subhead">
                            {propertyInfo.address.street}
                            <p>{address}</p>
                        </h2>
                        <TruncateMarkup lines={3} ellipsis={moreLink}>
                            <p className="kicker main-text-component-desc">
                                {propertyInfo.descriptionPlain}
                            </p>
                        </TruncateMarkup>
                    </div>
                </div>
            );
        case 'estate':
            let price = '';
            if (heroInfo.price.type === 'value' && heroInfo.price.value) {
                price = currencyFormat.format(heroInfo.price.value);
            } else if (heroInfo.price.type === 'range' && heroInfo.price.from && heroInfo.price.to) {
                price = `${currencyFormat.format(heroInfo.price.from)} - ${currencyFormat.format(heroInfo.price.to)}`;
            }
            let priceBlock = price
            ? (
                <h2>
                    <span className="line"></span>
                    <span className="lined-text">{price}</span>
                    <span className="line"></span>
                </h2>
            )
            : null;
            address = propertyInfo.address.street;
            address = address.length
                ? address + ', ' + propertyInfo.address.city
                : propertyInfo.address.city;
            address = address.length
                ? address + ', ' + propertyInfo.address.state
                : propertyInfo.address.state;

            return (
                <div className="main-text-component-wrapper">
                    <div className="main-text-component-content">
                        {priceBlock}
                        <h1 id="title-helper" className="letter-spacing-helper">{propertyInfo.title}</h1>
                        <h1 id="title">{propertyInfo.title}</h1>
                        <h2 id="subhead-helper" className="subhead letter-spacing-helper">{address}</h2>
                        <h2 id="subhead" className="subhead">{address}</h2>
                    </div>
                </div>
            )
        case 'modern':
            address = propertyInfo.address.state + ' ' + propertyInfo.address.zip;
            address = propertyInfo.address.city
                ? propertyInfo.address.city + ', ' + address
                : address;
            return (
                <div className="main-text-component-content">
                    <h1>{propertyInfo.title}</h1>
                    <h2 className="subhead">
                        {propertyInfo.address.street}
                        <p>{address}</p>
                    </h2>
                    <TruncateMarkup lines={3} ellipsis={moreLink}>
                        <p className="kicker main-text-component-desc">
                            {propertyInfo.descriptionPlain}
                        </p>
                    </TruncateMarkup>
                </div>
            )

        default:
            address = propertyInfo.address.state + ' ' + propertyInfo.address.zip;
            address = propertyInfo.address.city
                ? propertyInfo.address.city + ', ' + address
                : address;
            return (
                <div className="main-text-component-wrapper">
                    <div className="main-text-component-content">
                        <h1>{propertyInfo.address.street}</h1>
                        <h2 className="subhead">{address}</h2>
                        <TruncateMarkup lines={3} ellipsis={moreLink}>
                            <p className="kicker main-text-component-desc">
                                {propertyInfo.descriptionPlain}
                            </p>
                        </TruncateMarkup>
                    </div>
                </div>
            );
    }
}
